// 9fbef606107a605d69c0edbcd8029e5d
import { parseBoolean, getABtestFromState } from '@tcp/core/src/utils';
import { createSelector } from 'reselect';

export const getEddFeatureSwitch = (state) => {
  return parseBoolean(state.session.siteDetails.EDD_ENABLED);
};

export const getEddAllowedStates = (state) => {
  return state.session.siteDetails.EDD_ENABLED_STATES;
};

export const getEddCachingInterval = (state) => {
  const cachingTTL = state.session.siteDetails.EDD_CACHING_INTERVAL;
  if (typeof cachingTTL !== 'undefined') {
    return parseInt(cachingTTL, 10);
  }
  return cachingTTL;
};

const getEddState = (state) => {
  return state && state.Edd;
};

export const getEddData = (state) => {
  return state && state.Edd && state.Edd.get('eddData');
};

export const getItemsWithEDD = createSelector(
  getEddState,
  (eddState) => eddState && eddState.getIn(['eddData', 'itemsWithEdd'])
);

export const getOrderEddDates = createSelector(
  getEddState,
  (eddState) => eddState && eddState.getIn(['eddData', 'orderEddDates'])
);

export const getSelectedShippingCode = createSelector(
  getEddState,
  (eddState) => eddState && eddState.get('shippingCode')
);

export const getEddErrorState = (state) => {
  return state && state.Edd && state.Edd.get('eddError');
};

export const getFetchingState = (state) => {
  return state && state.Edd && state.Edd.get('isFetching');
};

export const getEddABState = (state) => {
  const disableEDDAB = state && state.AbTest && getABtestFromState(state.AbTest);
  return !(disableEDDAB && disableEDDAB.disableEDDFunctionality);
};
